import AuthenticationFooter from './AuthenticationFooter';
export default AuthenticationFooter;
